import AgencyMark from '../marks/AgencyMark'
import { usePrefs } from '@/state/prefs'
import { useBrand } from '@/state/useBrand'

/** The flag (or the active mission's mark) beside the wordmark. */
export default function Lockup({ compact = false }: { compact?: boolean }) {
  const { prefs } = usePrefs()
  const { mission, name, abbr } = useBrand()
  return (
    <span className={`mds-lockup${compact ? ' mds-lockup--compact' : ''}`}>
      <AgencyMark mission={mission} variant={prefs.mark} className="mds-lockup__mark" />
      <span className="mds-lockup__text">
        <span className="mds-lockup__abbr" aria-hidden="true">
          {abbr}
        </span>
        <span className="mds-lockup__word">{name}</span>
      </span>
    </span>
  )
}
